import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../../layout/Navbar";
import Footer from "../../layout/Footer";

const AboutUs = () => {
    const stats = [
        { value: "300+", label: "Active Students", icon: "bi-people" },
        { value: "20+", label: "Past Questions", icon: "bi-journal-text" },
        { value: "5+", label: "Years Coverage", icon: "bi-calendar-range" },
        { value: "99%", label: "Accuracy Rate", icon: "bi-check-circle" }
    ];

    const features = [
        {
            icon: "bi-shield-check",
            title: "Verified Content",
            description: "All answers are verified by subject matter experts and experienced educators"
        },
        {
            icon: "bi-search",
            title: "Smart Search",
            description: "Find exactly what you need with intelligent filtering by year, subject, and level"
        },
        {
            icon: "bi-download",
            title: "Instant Access",
            description: "Download materials immediately after payment with no waiting time"
        },
        {
            icon: "bi-phone",
            title: "Mobile Friendly",
            description: "Study on the go with our responsive platform accessible on any device"
        }
    ];

    const educationLevels = [
        { name: "BECE", description: "Basic Education Certificate Examination", color: "primary" },
        { name: "WASSCE", description: "West African Senior School Certificate", color: "success" },
        { name: "NABTEX", description: "Technical & Vocational Examinations", color: "warning" },
        { name: "University", description: "Undergraduate & Postgraduate", color: "info" }
    ];

    return (
        <>
            <Navbar />
            
            {/* Hero Section */}
            <section className="hero-section bg-gradient-primary py-2">
                <div className="container py-5">
                    <div className="row align-items-center">
                        <div className="col-lg-8">
                            <div className="hero-content" data-aos="fade-right">
                                <span className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-3 py-2 mb-3 d-inline-flex align-items-center">
                                    <i className="bi bi-info-circle me-2"></i>
                                    About PastQuestionsHub
                                </span>
                                <h1 className="display-4 fw-bold mb-4">
                                    Empowering Students Across <span className="text-gradient-primary">Ghana</span>
                                </h1>
                                <p className="lead text-muted mb-4">
                                    We're dedicated to providing comprehensive, verified past questions and answers 
                                    to help students excel in their exams and achieve academic success.
                                </p>
                                <div className="d-flex flex-wrap gap-3">
                                    <Link to="/questions" className="btn btn-primary btn-lg px-4">
                                        <i className="bi bi-search me-2"></i>
                                        Explore Questions
                                    </Link>
                                    <Link to="/contact" className="btn btn-outline-primary btn-lg px-4">
                                        <i className="bi bi-chat-dots me-2"></i>
                                        Contact Us
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="hero-visual" data-aos="fade-left" data-aos-delay="200">
                                <div className="position-relative">
                                    <img 
                                        src="/assets/img/abt.JPG" 
                                        alt="Students studying with PastQuestionsHub"
                                        className="img-fluid rounded-4 shadow-lg"
                                        onError={(e) => {
                                            e.target.src = "https://images.unsplash.com/photo-1523050854058-8df90110c9f1?auto=format&fit=crop&w=800&q=80";
                                        }}
                                    />
                                    <div className="floating-badge bg-white rounded-4 shadow-sm p-3 d-flex align-items-center position-absolute"
                                         style={{ top: '20px', right: '20px' }}>
                                        <div className="bg-primary bg-opacity-10 rounded-3 p-2 me-3">
                                            <i className="bi bi-mortarboard-fill text-primary fs-4"></i>
                                        </div>
                                        <div>
                                            <div className="fw-bold">15,000+</div>
                                            <small className="text-muted">Distinctions</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="stats-section py-5 bg-light">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="row g-4">
                                {stats.map((stat, index) => (
                                    <div className="col-md-3 col-sm-6" key={index}>
                                        <div className="stat-card text-center p-4 rounded-4 bg-white shadow-sm border-0" 
                                             data-aos="fade-up" data-aos-delay={index * 100}>
                                            <div className="stat-icon mb-3">
                                                <i className={`bi ${stat.icon} fs-1 text-primary`}></i>
                                            </div>
                                            <div className="stat-value display-5 fw-bold mb-2">{stat.value}</div>
                                            <div className="stat-label text-muted">{stat.label}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mission Section */}
            <section className="mission-section py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6" data-aos="fade-right">
                            <div className="mission-visual position-relative">
                                <img 
                                    src="/assets/img/2.jpg" 
                                    alt="Our Mission in Education"
                                    className="img-fluid rounded-4 shadow"
                                    onError={(e) => {
                                        e.target.src = "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80";
                                    }}
                                />
                                <div className="experience-badge bg-primary text-white rounded-pill px-4 py-2 d-inline-flex align-items-center position-absolute"
                                     style={{ bottom: '20px', left: '20px' }}>
                                    <i className="bi bi-award me-2"></i>
                                    <span>Trusted Since 2021</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="200">
                            <div className="mission-content ps-lg-5">
                                <span className="badge bg-warning bg-opacity-10 text-warning rounded-pill px-3 py-2 mb-3 d-inline-flex align-items-center">
                                    <i className="bi bi-bullseye me-2"></i>
                                    Our Mission
                                </span>
                                <h2 className="display-5 fw-bold mb-4">
                                    Revolutionizing Exam Preparation in Ghana
                                </h2>
                                <p className="lead text-muted mb-4">
                                    We believe every student deserves access to quality educational resources. 
                                    Our mission is to bridge the gap between students and academic success 
                                    through verified past questions and modern learning tools.
                                </p>
                                
                                <div className="mission-points">
                                    {[
                                        "Provide verified, accurate past questions",
                                        "Make education accessible and affordable",
                                        "Support students at all academic levels",
                                        "Foster a culture of academic excellence"
                                    ].map((point, index) => (
                                        <div className="d-flex align-items-start mb-3" key={index}>
                                            <i className="bi bi-check-circle-fill text-success me-3 mt-1"></i>
                                            <span>{point}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section className="features-section py-5 bg-light">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-8 text-center">
                            <span className="badge bg-info bg-opacity-10 text-info rounded-pill px-3 py-2 mb-3 d-inline-flex align-items-center">
                                <i className="bi bi-stars me-2"></i>
                                Why Choose Us
                            </span>
                            <h2 className="display-5 fw-bold mb-3">What Makes Us Different</h2>
                            <p className="lead text-muted">
                                We combine quality content with modern technology to deliver the best exam preparation experience
                            </p>
                        </div>
                    </div>
                    
                    <div className="row g-4">
                        {features.map((feature, index) => (
                            <div className="col-lg-3 col-md-6" key={index} data-aos="fade-up" data-aos-delay={index * 100}>
                                <div className="feature-card h-100 p-4 rounded-4 bg-white shadow-sm border-0">
                                    <div className="feature-icon mb-4">
                                        <div className="bg-primary bg-opacity-10 rounded-3 p-3 d-inline-block">
                                            <i className={`bi ${feature.icon} fs-2 text-primary`}></i>
                                        </div>
                                    </div>
                                    <h5 className="fw-bold mb-3">{feature.title}</h5>
                                    <p className="text-muted mb-0">{feature.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Education Levels */}
            <section className="levels-section py-5">
                <div className="container">
                    <div className="row justify-content-center mb-5">
                        <div className="col-lg-8 text-center">
                            <span className="badge bg-success bg-opacity-10 text-success rounded-pill px-3 py-2 mb-3 d-inline-flex align-items-center">
                                <i className="bi bi-mortarboard me-2"></i>
                                Comprehensive Coverage
                            </span>
                            <h2 className="display-5 fw-bold mb-3">All Education Levels Supported</h2>
                            <p className="lead text-muted">
                                From basic education to university level, we've got you covered
                            </p>
                        </div>
                    </div>
                    
                    <div className="row g-4">
                        {educationLevels.map((level, index) => (
                            <div className="col-lg-3 col-md-6" key={index} data-aos="zoom-in" data-aos-delay={index * 100}>
                                <div className={`level-card p-4 rounded-4 border-start border-5 border-${level.color} h-100`}>
                                    <div className="level-header mb-3">
                                        <span className={`badge bg-${level.color} bg-opacity-10 text-${level.color} rounded-pill px-3 py-2`}>
                                            {level.name}
                                        </span>
                                    </div>
                                    <h5 className="fw-bold mb-3">{level.name}</h5>
                                    <p className="text-muted mb-3">{level.description}</p>
                                    <Link to={`/questions/${level.name.toLowerCase()}`} 
                                          className={`btn btn-outline-${level.color} btn-sm`}>
                                        Browse Questions <i className="bi bi-arrow-right ms-2"></i>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section py-5 bg-gradient-primary">
                <div className="container">
                    <div className="row justify-content-center text-center">
                        <div className="col-lg-8">
                            <div className="cta-card bg-white rounded-4 p-5 shadow-lg">
                                <h2 className="display-5 fw-bold mb-3">Ready to Excel in Your Exams?</h2>
                                <p className="lead text-muted mb-4">
                                    Join thousands of successful students who have transformed their exam preparation with our platform
                                </p>
                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                   
                                    <Link to="/questions" className="btn btn-outline-primary btn-lg px-5">
                                        <i className="bi bi-search me-2"></i>
                                        Browse Questions
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <style jsx>{`
                .hero-section {
                    background: linear-gradient(135deg, rgba(13, 110, 253, 0.05) 0%, rgba(111, 66, 193, 0.05) 100%);
                    margin-top: 80px; /* For fixed navbar */
                }
                
                .bg-gradient-primary {
                    background: linear-gradient(135deg, rgba(13, 110, 253, 0.05) 0%, rgba(111, 66, 193, 0.05) 100%);
                }
                
                .text-gradient-primary {
                    background: linear-gradient(135deg, #0d6efd 0%, #6f42c1 100%);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    background-clip: text;
                }
                
                .stat-card, .feature-card, .level-card {
                    transition: all 0.3s ease;
                }
                
                .stat-card:hover, .feature-card:hover, .level-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
                }
                
                .floating-badge {
                    animation: float 3s ease-in-out infinite;
                }
                
                .experience-badge {
                    animation: pulse 2s infinite;
                }
                
                @keyframes float {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }
                
                @keyframes pulse {
                    0% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                    100% { transform: scale(1); }
                }
                
                .border-5 {
                    border-width: 5px !important;
                }
                
                .level-card {
                    background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0.95) 100%);
                }
                
                .mission-visual {
                    overflow: hidden;
                    border-radius: 20px;
                }
                
                .mission-visual img {
                    transition: transform 0.5s ease;
                }
                
                .mission-visual:hover img {
                    transform: scale(1.05);
                }
                
                .cta-card {
                    position: relative;
                    overflow: hidden;
                }
                
                .cta-card::before {
                    content: '';
                    position: absolute;
                    top: -50%;
                    right: -50%;
                    width: 200px;
                    height: 200px;
                    background: linear-gradient(45deg, rgba(13, 110, 253, 0.1) 0%, rgba(111, 66, 193, 0.1) 100%);
                    border-radius: 50%;
                }
                
                .cta-card::after {
                    content: '';
                    position: absolute;
                    bottom: -30%;
                    left: -30%;
                    width: 150px;
                    height: 150px;
                    background: linear-gradient(45deg, rgba(13, 110, 253, 0.05) 0%, rgba(111, 66, 193, 0.05) 100%);
                    border-radius: 50%;
                }
                
                /* Responsive adjustments */
                @media (max-width: 992px) {
                    .hero-section {
                        padding: 3rem 0;
                    }
                    
                    .display-4 {
                        font-size: 2.5rem;
                    }
                    
                    .display-5 {
                        font-size: 2rem;
                    }
                }
                
                @media (max-width: 768px) {
                    .hero-section {
                        padding: 2rem 0;
                        margin-top: 70px;
                    }
                    
                    .display-4 {
                        font-size: 2rem;
                    }
                    
                    .btn-lg {
                        padding: 0.75rem 1.5rem;
                        font-size: 1rem;
                    }
                    
                    .stat-card {
                        padding: 1.5rem !important;
                    }
                }
            `}</style>
            
            <Footer />
        </>
    );
};

export default AboutUs;